import { useDl } from "../utils/dlToken";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { EmailTemplates } from "./EmailTemplates";
import { FileText, ClipboardCheck, ScrollText, ShieldCheck, MailCheck, Send, Award, Download, ExternalLink, Loader2, Check, X, Search, User, Building2, GraduationCap } from "lucide-react";
import { openPdf } from "../utils/pdf";
import OnlineCertTemplate from "./OnlineCertTemplate";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SIGNED = {
  sk: [
    { Icon: MailCheck, type: "confirmation", title: "Potvrdenie prijatia žiadosti", file: "/potvrdenie-podpisane-saubereko.pdf" },
    { Icon: Send, type: "notice", title: "Oznámenie o zaradení do konania", file: "/oznamenie-podpisane-saubereko.pdf" },
    { Icon: Award, type: "congrats", title: "Gratulácia k certifikácii", file: "/gratulacia-podpisane-saubereko.pdf" },
    { Icon: Building2, type: "integration", title: "Integračná ponuka (adresát meniteľný)", file: "/integracna-ponuka-saubereko-sk.pdf" },
    { Icon: ScrollText, type: "partnership", title: "Strategické partnerstvo (adresát meniteľný)", file: "/strategicke-partnerstvo-saubereko-sk.pdf" },
    { Icon: FileText, type: "mentor", title: "Sprievodca pre mentora (investor meniteľný)", file: "/sprievodca-mentor-saubereko-sk.pdf" },
    { Icon: ScrollText, type: "school", title: "Spolupráca — zváračská škola (názov meniteľný)", file: "/skola-spolupraca-saubereko-sk.pdf" },
    { Icon: Award, type: "uhp", title: "UHP kurz (spoločnosť meniteľná)", file: "/uhp-kurz-saubereko-sk.pdf" },
    { Icon: Building2, type: "uhp_centrum", title: "Tréningové centrum UHP & Clean Room (nábor)", file: "/uhp-centrum-saubereko-sk.pdf" },
    { Icon: Building2, type: "uhp_navrh", title: "Návrh projektu — UHP tréningové centrum (B2B, firma meniteľná)", file: "/uhp-centrum-navrh-saubereko.pdf" },
    { Icon: Award, type: "bosch", title: "Bosch — technologické partnerstvo (oficiálny)", file: "/bosch-partnerstvo-saubereko-sk.pdf" },
    { Icon: FileText, type: "tig", title: "Tréningové centrum TIG (141) — zváranie v zahraničí", file: "/tig-trening-saubereko.pdf" },
    { Icon: FileText, type: "investor", title: "Pre investorov — leták (Platíte za profesionálov…)", file: "/pre-investorov-saubereko.pdf" },
    { Icon: FileText, type: "brand", title: "Čo je SauberEko® — leták o značke", file: "/co-je-saubereko.pdf" },
    { Icon: FileText, type: "cennik", title: "Cenník certifikácie 2026 (oficiálny)", file: "/cennik-saubereko.pdf" },
  ],
  en: [
    { Icon: MailCheck, type: "confirmation", title: "Confirmation of receipt", file: "/potvrdenie-podpisane-saubereko-en.pdf" },
    { Icon: Send, type: "notice", title: "Notice of inclusion", file: "/oznamenie-podpisane-saubereko-en.pdf" },
    { Icon: Award, type: "congrats", title: "Congratulations on certification", file: "/gratulacia-podpisane-saubereko-en.pdf" },
    { Icon: Building2, type: "integration", title: "Integration offer (recipient editable)", file: "/integracna-ponuka-saubereko-en.pdf" },
    { Icon: ScrollText, type: "partnership", title: "Strategic partnership (recipient editable)", file: "/strategicke-partnerstvo-saubereko-en.pdf" },
    { Icon: FileText, type: "mentor", title: "Mentor guide (investor editable)", file: "/sprievodca-mentor-saubereko-en.pdf" },
    { Icon: ScrollText, type: "school", title: "Cooperation — welding school (name editable)", file: "/skola-spolupraca-saubereko-en.pdf" },
    { Icon: Award, type: "uhp", title: "UHP course (company editable)", file: "/uhp-kurz-saubereko-en.pdf" },
    { Icon: Building2, type: "uhp_centrum", title: "UHP & Clean Room training centre (recruitment)", file: "/uhp-centrum-saubereko-en.pdf" },
    { Icon: Building2, type: "uhp_navrh", title: "Project proposal — UHP training centre (B2B, company editable)", file: "/uhp-centrum-navrh-saubereko-en.pdf" },
    { Icon: Award, type: "bosch", title: "Bosch — technological partnership (official)", file: "/bosch-partnerstvo-saubereko-en.pdf" },
  ],
  de: [
    { Icon: MailCheck, type: "confirmation", title: "Eingangsbestätigung", file: "/potvrdenie-podpisane-saubereko-de.pdf" },
    { Icon: Send, type: "notice", title: "Aufnahmemitteilung", file: "/oznamenie-podpisane-saubereko-de.pdf" },
    { Icon: Award, type: "congrats", title: "Gratulation zur Zertifizierung", file: "/gratulacia-podpisane-saubereko-de.pdf" },
    { Icon: Building2, type: "integration", title: "Integrationsangebot (Empfänger änderbar)", file: "/integracna-ponuka-saubereko-de.pdf" },
    { Icon: ScrollText, type: "partnership", title: "Strategische Partnerschaft (Empfänger änderbar)", file: "/strategicke-partnerstvo-saubereko-de.pdf" },
    { Icon: FileText, type: "mentor", title: "Mentor-Leitfaden (Investor änderbar)", file: "/sprievodca-mentor-saubereko-de.pdf" },
    { Icon: ScrollText, type: "school", title: "Zusammenarbeit — Schweißschule (Name änderbar)", file: "/skola-spolupraca-saubereko-de.pdf" },
    { Icon: Award, type: "uhp", title: "UHP-Kurs (Unternehmen änderbar)", file: "/uhp-kurz-saubereko-de.pdf" },
    { Icon: Building2, type: "uhp_centrum", title: "UHP & Clean Room Trainingszentrum (Rekrutierung)", file: "/uhp-centrum-saubereko-de.pdf" },
    { Icon: Building2, type: "uhp_navrh", title: "Projektvorschlag — UHP-Schulungszentrum (B2B, Unternehmen änderbar)", file: "/uhp-centrum-navrh-saubereko-de.pdf" },
    { Icon: Award, type: "bosch", title: "Bosch — technologische Partnerschaft (offiziell)", file: "/bosch-partnerstvo-saubereko-de.pdf" },
  ],
  pl: [
    { Icon: MailCheck, type: "confirmation", title: "Potwierdzenie przyjęcia wniosku", file: "/potvrdenie-podpisane-saubereko-pl.pdf" },
    { Icon: Send, type: "notice", title: "Zawiadomienie o włączeniu", file: "/oznamenie-podpisane-saubereko-pl.pdf" },
    { Icon: Award, type: "congrats", title: "Gratulacje z certyfikacji", file: "/gratulacia-podpisane-saubereko-pl.pdf" },
    { Icon: Building2, type: "integration", title: "Oferta integracji (adresat edytowalny)", file: "/integracna-ponuka-saubereko-pl.pdf" },
    { Icon: ScrollText, type: "partnership", title: "Partnerstwo strategiczne (adresat edytowalny)", file: "/strategicke-partnerstvo-saubereko-pl.pdf" },
    { Icon: FileText, type: "mentor", title: "Przewodnik dla mentora (inwestor edytowalny)", file: "/sprievodca-mentor-saubereko-pl.pdf" },
    { Icon: ScrollText, type: "school", title: "Współpraca — szkoła spawania (nazwa edytowalna)", file: "/skola-spolupraca-saubereko-pl.pdf" },
    { Icon: Award, type: "uhp", title: "Kurs UHP (spółka edytowalna)", file: "/uhp-kurz-saubereko-pl.pdf" },
    { Icon: Building2, type: "uhp_centrum", title: "Centrum szkoleniowe UHP & Clean Room (rekrutacja)", file: "/uhp-centrum-saubereko-pl.pdf" },
    { Icon: Building2, type: "uhp_navrh", title: "Propozycja projektu — centrum szkoleniowe UHP (B2B, firma edytowalna)", file: "/uhp-centrum-navrh-saubereko-pl.pdf" },
    { Icon: Award, type: "bosch", title: "Bosch — partnerstwo technologiczne (oficjalne)", file: "/bosch-partnerstvo-saubereko-pl.pdf" },
  ],
};

const SCHOOL = [
  { Icon: ShieldCheck, type: "cert_verified", title: "Potvrdenie — Preverený mentorom SauberEko®", file: "/potvrdenie-preverenie-saubereko.pdf" },
  { Icon: GraduationCap, type: "cert_graduate", title: "Potvrdenie o absolvovaní — Work, learn and earn©", file: "/potvrdenie-absolvent-saubereko.pdf" },
  { Icon: Award, type: "cert_doskolenie", title: "Potvrdenie o doškolení v Tréningovom centre", file: "/potvrdenie-doskolenie-saubereko.pdf" },
];

const UNSIGNED = {
  sk: [
    { Icon: ScrollText, title: "Zmluva o mlčanlivosti (NDA)", file: "/nda-mlcanlivost-saubereko.pdf" },
    { Icon: ShieldCheck, title: "Dohoda o mlčanlivosti — uchádzač (NDA)", file: "/nda-uchadzac-saubereko.pdf" },
    { Icon: Send, title: "B2B ponuka spolupráce (obchodný list)", file: "/b2b-list-spolupraca-saubereko.pdf" },
    { Icon: ClipboardCheck, title: "Audítny protokol (kontrola na prevádzke)", file: "/audit-protokol-saubereko.pdf" },
    { Icon: ScrollText, title: "Postup certifikácie", file: "/postup-certifikacie-saubereko.pdf" },
    { Icon: ClipboardCheck, title: "Žiadosť o certifikáciu", file: "/ziadost-certifikacia-saubereko.pdf" },
    { Icon: FileText, title: "Kódex profesijnej integrity", file: "/kodex-saubereko-2026.pdf" },
    { Icon: ShieldCheck, title: "Súhlas so spracúvaním údajov (GDPR)", file: "/suhlas-spracovanie-udajov-saubereko.pdf" },
    { Icon: MailCheck, title: "Potvrdenie prijatia žiadosti", file: "/potvrdenie-prijatia-ziadosti-saubereko.pdf" },
    { Icon: Send, title: "Oznámenie o zaradení do konania", file: "/oznamenie-zaradenie-konanie-saubereko.pdf" },
    { Icon: Award, title: "Gratulácia k certifikácii", file: "/gratulacia-certifikacia-saubereko.pdf" },
  ],
  en: [
    { Icon: ScrollText, title: "Non-Disclosure Agreement (NDA)", file: "/nda-mlcanlivost-saubereko-en.pdf" },
    { Icon: ShieldCheck, title: "Confidentiality Agreement — applicant (NDA)", file: "/nda-uchadzac-saubereko-en.pdf" },
    { Icon: Send, title: "B2B partnership proposal (letter)", file: "/b2b-list-spolupraca-saubereko-en.pdf" },
    { Icon: ClipboardCheck, title: "On-site Audit Protocol", file: "/audit-protokol-saubereko-en.pdf" },
    { Icon: ScrollText, title: "Certification process", file: "/postup-certifikacie-saubereko-en.pdf" },
    { Icon: ClipboardCheck, title: "Application for certification", file: "/ziadost-certifikacia-saubereko-en.pdf" },
    { Icon: FileText, title: "Code of Professional Integrity", file: "/kodex-saubereko-2026-en.pdf" },
    { Icon: ShieldCheck, title: "Personal data processing consent (GDPR)", file: "/suhlas-spracovanie-udajov-saubereko-en.pdf" },
  ],
  de: [
    { Icon: ScrollText, title: "Geheimhaltungsvereinbarung (NDA)", file: "/nda-mlcanlivost-saubereko-de.pdf" },
    { Icon: ShieldCheck, title: "Vertraulichkeitsvereinbarung — Antragsteller (NDA)", file: "/nda-uchadzac-saubereko-de.pdf" },
    { Icon: Send, title: "B2B-Kooperationsangebot (Brief)", file: "/b2b-list-spolupraca-saubereko-de.pdf" },
    { Icon: ClipboardCheck, title: "Auditprotokoll (Vor-Ort-Kontrolle)", file: "/audit-protokol-saubereko-de.pdf" },
    { Icon: ScrollText, title: "Zertifizierungsablauf", file: "/postup-certifikacie-saubereko-de.pdf" },
    { Icon: ClipboardCheck, title: "Antrag auf Zertifizierung", file: "/ziadost-certifikacia-saubereko-de.pdf" },
    { Icon: FileText, title: "Kodex der beruflichen Integrität", file: "/kodex-saubereko-2026-de.pdf" },
    { Icon: ShieldCheck, title: "Einwilligung zur Datenverarbeitung (DSGVO)", file: "/suhlas-spracovanie-udajov-saubereko-de.pdf" },
  ],
  pl: [
    { Icon: ScrollText, title: "Umowa o zachowaniu poufności (NDA)", file: "/nda-mlcanlivost-saubereko-pl.pdf" },
    { Icon: ShieldCheck, title: "Umowa o poufności — wnioskodawca (NDA)", file: "/nda-uchadzac-saubereko-pl.pdf" },
    { Icon: Send, title: "Oferta współpracy B2B (list)", file: "/b2b-list-spolupraca-saubereko-pl.pdf" },
    { Icon: ClipboardCheck, title: "Protokół audytu (kontrola na miejscu)", file: "/audit-protokol-saubereko-pl.pdf" },
    { Icon: ScrollText, title: "Proces certyfikacji", file: "/postup-certifikacie-saubereko-pl.pdf" },
    { Icon: ClipboardCheck, title: "Wniosek o certyfikację", file: "/ziadost-certifikacia-saubereko-pl.pdf" },
    { Icon: FileText, title: "Kodeks integralności zawodowej", file: "/kodex-saubereko-2026-pl.pdf" },
    { Icon: ShieldCheck, title: "Zgoda na przetwarzanie danych (RODO)", file: "/suhlas-spracovanie-udajov-saubereko-pl.pdf" },
  ],
};

const LANGS = [["sk", "Tlačivá SK 🇸🇰"], ["de", "Tlačivá DE 🇩🇪"], ["en", "Tlačivá EN 🇬🇧"], ["pl", "Tlačivá PL 🇵🇱"]];
const LANG_SUFFIX = { sk: "", en: "-en", de: "-de", pl: "-pl" };

// Priradenie kľúča dokumentu podľa názvu súboru + či sa dá personalizovať (fill)
function docMeta(file) {
  const f = file || "";
  if (f.includes("nda-uchadzac")) return { key: "nda_uchadzac", fill: true };
  if (f.includes("nda-mlcanlivost")) return { key: "nda", fill: true };
  if (f.includes("b2b-list")) return { key: "b2b", fill: true };
  if (f.includes("audit-protokol")) return { key: "audit", fill: true };
  if (f.includes("potvrdenie-prijatia")) return { key: "confirmation", fill: true };
  if (f.includes("oznamenie-zaradenie")) return { key: "notice", fill: true };
  if (f.includes("gratulacia-certifikacia")) return { key: "congrats", fill: true };
  if (f.includes("postup-certifikacie")) return { key: "postup", fill: false };
  if (f.includes("ziadost-certifikacia")) return { key: "ziadost", fill: false };
  if (f.includes("kodex-saubereko")) return { key: "kodex", fill: false };
  if (f.includes("suhlas-spracovanie")) return { key: "gdpr", fill: false };
  return { key: "", fill: false };
}

function DocCard({ Icon, title, file, testidBase, onFill }) {
  return (
    <div data-testid={testidBase} className="border border-white/10 bg-[#0a0a0a] p-6 hover:border-[#D4AF37]/40 transition-colors flex flex-col">
      <span className="w-12 h-12 flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] mb-5"><Icon size={22} strokeWidth={1.5} /></span>
      <h3 className="font-display text-lg mb-4 flex-1">{title}</h3>
      <div className="flex items-center gap-2 flex-wrap">
        <button type="button" onClick={() => openPdf(file)} data-testid={`${testidBase}-view`}
          className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 text-xs hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"><ExternalLink size={14} /> Prázdny</button>
        {onFill && (
          <button type="button" onClick={onFill} data-testid={`${testidBase}-fill`}
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black px-3 py-2 text-xs font-semibold hover:bg-[#F2E3C6] transition-colors">
            <Search size={14} /> Vyplniť / Odoslať
          </button>
        )}
      </div>
    </div>
  );
}

export default function AdminTemplates({ token, onCompose }) {
  const dl = useDl(token);
  const [activeLang, setActiveLang] = useState("sk");
  const [doc, setDoc] = useState(null); // { key, title, fill }
  const [form, setForm] = useState({ email: "", name: "", ico: "", evidence: "", address: "" });
  const [busy, setBusy] = useState(false);
  const [okMsg, setOkMsg] = useState("");
  const [error, setError] = useState("");

  const openDoc = (key, title, fill) => {
    setDoc({ key, title, fill });
    setForm({ email: "", name: "", ico: "", evidence: "", address: "", record_id: "" });
    setError(""); setOkMsg("");
  };

  const fetchPdf = async () => {
    const res = await axios.post(`${API}/admin/templates/doc`, {
      key: doc.key, lang: activeLang, title: doc.title, mode: "download",
      name: form.name.trim(), ico: form.ico.trim(), evidence: form.evidence.trim(), address: form.address.trim(), record_id: form.record_id || null,
    }, { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" });
    return window.URL.createObjectURL(res.data);
  };

  const handleOpen = async () => {
    setBusy(true); setError("");
    try { const url = await fetchPdf(); window.open(url, "_blank"); }
    catch { setError("Nepodarilo sa vytvoriť dokument."); }
    finally { setBusy(false); }
  };

  const handleDownload = async () => {
    setBusy(true); setError("");
    try {
      const url = await fetchPdf();
      const a = document.createElement("a");
      a.href = url; a.download = `${doc.key}-saubereko.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
    } catch { setError("Nepodarilo sa vytvoriť dokument."); }
    finally { setBusy(false); }
  };

  const handleEmail = async (e) => {
    e.preventDefault();
    if (!form.email.trim()) { setError("Zadajte e-mail príjemcu."); return; }
    setBusy(true); setError(""); setOkMsg("");
    try {
      await axios.post(`${API}/admin/templates/doc`, {
        key: doc.key, lang: activeLang, title: doc.title, mode: "email", email: form.email.trim(),
        name: form.name.trim(), ico: form.ico.trim(), evidence: form.evidence.trim(), address: form.address.trim(), record_id: form.record_id || null,
      }, { headers: { Authorization: `Bearer ${token}` } });
      setOkMsg(`Odoslané na ${form.email.trim()}`);
    } catch (err) { setError(err.response?.data?.detail || "Odoslanie zlyhalo."); }
    finally { setBusy(false); }
  };

  const signed = SIGNED[activeLang];
  const unsigned = UNSIGNED[activeLang];

  return (
    <div data-testid="admin-templates">
      <div className="flex items-center gap-2 mb-8 flex-wrap" data-testid="templates-lang-tabs">
        {LANGS.map(([code, label]) => (
          <button key={code} onClick={() => setActiveLang(code)} data-testid={`templates-lang-${code}`}
            className={`px-4 py-2 text-sm border transition-colors ${activeLang === code ? "bg-[#D4AF37] text-black border-[#D4AF37] font-semibold" : "border-white/15 text-white/60 hover:border-[#D4AF37]/50"}`}>
            {label}
          </button>
        ))}
      </div>

      <div className="mb-12" data-testid="owner-assets">
        <h2 className="font-display text-2xl mb-1">Pečiatka a podpis</h2>
        <p className="text-white/40 text-sm mb-4">Vaša uložená pečiatka a podpis — dostupné len Vám po prihlásení. Použiteľné na podpisovanie budúcich dokumentov.</p>
        <div className="grid sm:grid-cols-3 gap-4">
          {[["combined", "Pečiatka + podpis"], ["signature", "Podpis"], ["stamp", "Pečiatka"]].map(([k, label]) => (
            <div key={k} data-testid={`owner-asset-${k}`} className="border border-white/10 bg-[#0a0a0a] p-5 flex flex-col">
              <div className="bg-white rounded p-3 mb-4 flex items-center justify-center h-36">
                {dl && <img src={`${API}/admin/owner-asset/${k}?token=${dl}`} alt={label} className="max-h-28 max-w-full object-contain" />}
              </div>
              <h3 className="font-display text-base mb-3 flex-1">{label}</h3>
              <div className="flex items-center gap-2">
                <a href={`${API}/admin/owner-asset/${k}?token=${dl}`} target="_blank" rel="noreferrer" data-testid={`owner-asset-${k}-open`}
                  className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 text-xs hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"><ExternalLink size={14} /> Otvoriť</a>
                <a href={`${API}/admin/owner-asset/${k}?token=${dl}`} download={`saubereko-${k}.png`} data-testid={`owner-asset-${k}-download`}
                  className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 text-xs hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"><Download size={14} /> Stiahnuť</a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {onCompose && <EmailTemplates onCompose={onCompose} token={token} />}

      <div className="mb-4">
        <h2 className="font-display text-2xl mb-1" data-testid="school-center-title">Školiace centrum</h2>
        <p className="text-white/40 text-sm">Certifikáty centra (čierno-zlatý dizajn) — Preverený, Absolvent a Doškolenie. Číslo karty zadáva mentor. Vyhľadajte osobu (aj podľa IČO/Card ID), predvyplňte a stiahnite či odošlite.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
        {SCHOOL.map((d) => (
          <DocCard key={d.type} {...d} file={d.file.replace(".pdf", `${LANG_SUFFIX[activeLang]}.pdf`)} testidBase={`school-${d.type}`}
            onFill={() => openDoc(d.type, d.title, true)} />
        ))}
      </div>
      <OnlineCertTemplate token={token} lang={activeLang === "en" || activeLang === "de" || activeLang === "pl" ? activeLang : "sk"} />

      <div className="mb-4">
        <h2 className="font-display text-2xl mb-1">Podpísané dokumenty</h2>
        <p className="text-white/40 text-sm">Zlato-biele listy s Vaším podpisom a pečiatkou v jazyku {activeLang.toUpperCase()} — vyhľadajte zákazníka (aj podľa IČO), predvyplňte a odošlite alebo stiahnite.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
        {signed.map((d) => (
          <DocCard key={d.type} {...d} testidBase={`signed-${activeLang}-${d.type}`}
            onFill={() => openDoc(d.type, d.title, true)} />
        ))}
      </div>

      <div className="mb-4 pt-2 border-t border-white/10">
        <h2 className="font-display text-2xl mb-1 mt-6">Tlačivá</h2>
        <p className="text-white/40 text-sm">Oficiálne dokumenty — otvorte prázdny náhľad, alebo vyhľadajte zákazníka (aj podľa IČO), predvyplňte a rovno stiahnite či odošlite e-mailom.</p>
      </div>
      {unsigned.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {unsigned.map((d, i) => {
            const m = docMeta(d.file);
            return <DocCard key={i} {...d} testidBase={`template-${activeLang}-${i}`}
              onFill={m.key ? () => openDoc(m.key, d.title, m.fill) : undefined} />;
          })}
        </div>
      ) : (
        <div className="border border-dashed border-white/15 p-6 text-white/40 text-sm" data-testid="templates-empty">
          Tlačivá v jazyku {activeLang.toUpperCase()} sa pripravujú (preklad prebieha). Listy (Potvrdenie/Oznámenie/Gratulácia) sú už dostupné vyššie.
        </div>
      )}

      {doc && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4" data-testid="send-signed-modal">
          <div className="w-full max-w-md bg-[#0a0a0a] border border-[#D4AF37]/30 shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 sticky top-0 bg-[#0a0a0a]">
              <div>
                <p className="text-[10px] uppercase tracking-wider text-[#D4AF37]">Vyplniť a odoslať · {activeLang.toUpperCase()}</p>
                <h3 className="font-display text-lg text-white mt-0.5">{doc.title}</h3>
              </div>
              <button onClick={() => setDoc(null)} data-testid="send-modal-close" className="text-white/40 hover:text-white"><X size={20} /></button>
            </div>
            <form onSubmit={handleEmail} className="p-6 space-y-4">
              {doc.fill ? (
                <>
                  {CERT_KIND[doc.key] ? (
                    <RecordSearch token={token} kind={CERT_KIND[doc.key]} picked={form.record_id} onPick={(r) => setForm((f) => ({
                      ...f, email: r.subject_email || f.email, name: r.subject_name || "", ico: r.card_id || "", evidence: r.record_no || "", address: r.area || "", record_id: r.id,
                    }))} onClear={() => setForm((f) => ({ ...f, record_id: "" }))} />
                  ) : (
                    <ApplicantSearch token={token} onPick={(r) => setForm((f) => ({
                      ...f, email: r.email || f.email, name: r.name || "", ico: r.ico || "", evidence: r.evidence_number || "", address: r.address || "",
                    }))} />
                  )}
                  <Field label="Meno / Firma (do dokumentu)" value={form.name} testid="send-name" onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="Vloží sa do dokumentu" />
                  <Field label={CERT_KIND[doc.key] ? "Card ID" : "IČO"} value={form.ico} testid="send-ico" onChange={(e) => setForm((f) => ({ ...f, ico: e.target.value }))} placeholder={CERT_KIND[doc.key] ? "napr. 0281845" : "napr. 12345678"} />
                  {!CERT_KIND[doc.key] && <Field label="Evidenčné / Certifikát č." value={form.evidence} testid="send-evidence" onChange={(e) => setForm((f) => ({ ...f, evidence: e.target.value }))} placeholder="napr. Sa.Eko.Prs. 2026-0016" />}
                  <Field label={CERT_KIND[doc.key] ? "Oblasť / odbor" : "Sídlo / Adresa"} value={form.address} testid="send-address" onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))} placeholder={CERT_KIND[doc.key] ? "napr. Zváranie TIG" : "Ulica, mesto"} />
                </>
              ) : (
                <p className="text-white/50 text-xs border border-white/10 bg-white/[0.03] p-3" data-testid="doc-general-note">
                  Tento dokument je všeobecný (bez personalizácie). Môžete ho rovno stiahnuť alebo odoslať e-mailom.
                </p>
              )}
              <Field label="E-mail príjemcu (pre odoslanie)" type="email" value={form.email} testid="send-email" onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="komu poslať — aj sebe" />
              {error && <p className="text-red-400 text-sm" data-testid="send-modal-error">{error}</p>}
              {okMsg && <p className="text-emerald-400 text-sm flex items-center gap-1.5" data-testid="send-modal-ok"><Check size={14} /> {okMsg}</p>}
              <div className="flex items-center gap-2 pt-1 flex-wrap">
                <button type="button" onClick={handleOpen} disabled={busy} data-testid="doc-open-btn"
                  className="inline-flex items-center gap-2 border border-white/15 px-4 py-2.5 text-sm text-white/80 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors disabled:opacity-50">
                  <ExternalLink size={15} /> Otvoriť
                </button>
                <button type="button" onClick={handleDownload} disabled={busy} data-testid="doc-download-btn"
                  className="inline-flex items-center gap-2 border border-white/15 px-4 py-2.5 text-sm text-white/80 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors disabled:opacity-50">
                  <Download size={15} /> Stiahnuť
                </button>
                <button type="submit" disabled={busy} data-testid="send-modal-submit"
                  className="flex-1 bg-[#D4AF37] text-black font-semibold py-2.5 px-4 hover:bg-[#F2E3C6] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2">
                  {busy ? <><Loader2 size={16} className="animate-spin" /> Pracujem…</> : <><Send size={16} /> Odoslať e-mailom</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const CERT_KIND = { cert_verified: "verified", cert_graduate: "graduate", cert_doskolenie: "training" };

function RecordSearch({ token, kind, picked, onPick, onClear }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/admin/mentor-audits/search`, { params: { q: q.trim(), kind }, headers: { Authorization: `Bearer ${token}` } });
        setRes(data || []);
      } catch { setRes([]); }
    }, 300);
    return () => clearTimeout(t);
  }, [q, kind, token]);
  return (
    <div className="relative border border-[#D4AF37]/25 bg-[#D4AF37]/[0.05] p-3" data-testid="template-record-search">
      <label className="block text-[10px] uppercase tracking-wider text-[#D4AF37] mb-1.5">Predvyplniť zo schválených (mentor + admin)</label>
      <div className="relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/35" />
        <input value={q} onChange={(e) => { setQ(e.target.value); setSel(null); onClear(); }} placeholder="Meno, Card ID alebo evidenčné číslo…" data-testid="template-record-search-input"
          className="w-full bg-[#111] border border-white/15 pl-8 pr-3 py-2 text-sm text-white focus:outline-none focus:border-[#D4AF37]" />
      </div>
      {picked && sel && (
        <p className="text-emerald-400/90 text-xs mt-2 flex items-center gap-1.5" data-testid="template-record-picked">
          <Check size={12} /> {sel.record_no} · {sel.subject_name} — podpisy mentora aj admina, dátum a číslo sa doplnia automaticky
        </p>
      )}
      {res.length > 0 && !sel && (
        <div className="absolute left-0 right-0 top-full mt-1 z-10 bg-[#0c0c0c] border border-[#D4AF37]/40 shadow-2xl max-h-64 overflow-y-auto" data-testid="template-record-results">
          {res.map((r, i) => (
            <button type="button" key={r.id} onClick={() => { setSel(r); setRes([]); setQ(r.subject_name); onPick(r); }} data-testid={`template-record-result-${i}`}
              className="w-full text-left px-3 py-2 hover:bg-[#D4AF37]/10 border-b border-white/5 last:border-0">
              <span className="text-white text-sm">{r.subject_name}</span>
              <span className="block text-white/40 text-xs">{r.record_no} · Card ID {r.card_id} · {r.area || "—"} · mentor {r.mentor_name}</span>
            </button>
          ))}
        </div>
      )}
      {q.trim().length >= 2 && res.length === 0 && !sel && <p className="text-white/40 text-xs mt-2" data-testid="template-record-empty">Nič sa nenašlo medzi schválenými.</p>}
    </div>
  );
}

function Field({ label, testid, ...props }) {
  return (
    <label className="block">
      <span className="block text-xs text-white/50 mb-1.5">{label}</span>
      <input {...props} data-testid={testid}
        className="w-full bg-[#111] border border-white/15 px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#D4AF37] transition-colors" />
    </label>
  );
}

function ApplicantSearch({ token, onPick }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState(null);
  const boxRef = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    const term = q.trim();
    if (term.length < 2) { setResults([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/admin/applicants/search`, {
          params: { q: term }, headers: { Authorization: `Bearer ${token}` },
        });
        setResults(data || []); setOpen(true);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 300);
    return () => timer.current && clearTimeout(timer.current);
  }, [q, token]);

  const pick = (r) => {
    onPick(r);
    setPicked(r);
    setQ("");
    setResults([]);
    setOpen(false);
  };

  return (
    <div className="relative border border-[#D4AF37]/25 bg-[#D4AF37]/[0.05] p-3" ref={boxRef} data-testid="template-applicant-search">
      <span className="block text-xs text-[#D4AF37] mb-1.5 font-semibold">Vyhľadať firmu / jednotlivca (predvyplní údaje)</span>
      <div className="relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => results.length && setOpen(true)}
          placeholder="Meno, e-mail, IČO alebo názov firmy…"
          data-testid="template-search-input"
          className="w-full bg-[#111] border border-white/15 pl-9 pr-9 py-2.5 text-sm text-white focus:outline-none focus:border-[#D4AF37] transition-colors" />
        {loading && <Loader2 size={15} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#D4AF37] animate-spin" />}
      </div>
      {picked && (
        <p className="text-emerald-400/90 text-xs mt-2 flex items-center gap-1.5" data-testid="template-search-picked">
          <Check size={13} /> Predvyplnené: {picked.name || picked.email}
        </p>
      )}
      {open && results.length > 0 && (
        <div className="absolute left-0 right-0 top-full mt-1 z-10 bg-[#0c0c0c] border border-[#D4AF37]/40 shadow-2xl max-h-64 overflow-y-auto" data-testid="template-search-results">
          {results.map((r, i) => (
            <button
              type="button" key={i} onClick={() => pick(r)} data-testid={`template-search-result-${i}`}
              className="w-full text-left px-3 py-2.5 hover:bg-[#D4AF37]/10 border-b border-white/5 last:border-0 flex items-start gap-2.5">
              {r.type === "company" ? <Building2 size={15} className="text-[#D4AF37] shrink-0 mt-0.5" /> : <User size={15} className="text-[#D4AF37] shrink-0 mt-0.5" />}
              <span className="min-w-0">
                <span className="block text-sm text-white truncate">{r.name || "—"}</span>
                <span className="block text-xs text-white/45 truncate">{r.email}{r.ico ? ` · IČO ${r.ico}` : ""}{r.evidence_number ? ` · ${r.evidence_number}` : ""}</span>
              </span>
            </button>
          ))}
        </div>
      )}
      {open && !loading && results.length === 0 && q.trim().length >= 2 && (
        <p className="text-white/40 text-xs mt-2" data-testid="template-search-empty">Nič sa nenašlo.</p>
      )}
    </div>
  );
}
